var map = {
	"./avatar.svg": 985,
	"./avatar100x100.png": 890,
	"./avatar150x150.png": 821,
	"./avatar400x400.png": 996,
	"./avatar80x80.png": 313,
	"./favicon.ico": 986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;